import React from 'react';

import AntVoucherCreationPopup from './AntVoucherCreationPopup';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
    }

    async show(defaultObj) {
        if (this.popup) this.popup.show(defaultObj);
    }

    render() {
        return (
            <React.Fragment>
                <AntVoucherCreationPopup
                    ref={(ref) => (this.popup = ref)}
                    API={this.props.API}
                    session={this.props.session}
                    actionName={this.props.actionName}
                    width={this.props.width}
                    widthDefault={this.props.widthDefault}
                    title={this.props.title}
                    postFields={this.props.postFields}
                    navigateLink={this.props.navigateLink}
                    navigateField={this.props.navigateField}
                    header={this.props.header}
                    onSaved={this.props.onSaved}
                    tabs={this.props.tabs}
                    footer={this.props.footer}
                ></AntVoucherCreationPopup>
            </React.Fragment>
        );
    }
}
